import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router} from '@angular/router';
import decode from 'jwt-decode';
import {PermissionEnum} from '@services/permission/permission.enum';
import {CookieService} from 'ngx-cookie-service';
import {OctAuthKeysEnum} from '@core/auth';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const {
    data: {permission}
  } = route;

  const cookieService = inject(CookieService);
  const router = inject(Router);

  const userToken = cookieService.get(OctAuthKeysEnum.UserToken);
  const data = decode(userToken).permissions;
  const index = data.indexOf(permission);

  if (permission === PermissionEnum.Company.ViewInformation && index === -1) {
    router.navigate(['company/people']);
  }

  return index > -1;
};
